/*
 general javascript live agent helper code that can be use outside of angular that provide
 programmatic layer around the live agent code.

 problem it solved.
 It was suggested we do copy & paste snipt code for deployment code,  buttons and invitations. This code about reduce snipt code configuration id.
 so development & prod only need to have one version of the code with different configuration pass it.

 each rule for invitation require a copy of a code snipt to be in the page when the invivation is html code (and not mere images).
 So 10 rule will add 10 inviation. And adding or removing a rule will require modification the client.
 add a layer of obstration so one invitation ui and remove the need to update the code for new rule add or remove

 setting prechat form after page had initalized is giving "You cannot add a detail after page initialization.".
 there was an iframe hack for it but it too complicated and doesn't work will.
 fixed by adding to postMessage message from parent to prechat window instead

 time on page logic doesn't work with with SPA route changes. add custom url timing

 live agent code expect the chat buttons and invite ui to be in dom when it load.
 That is not always true for SPA, add code to handle it.


 */

(function() {
  var document,
    win,
    $ = window.jQueryArrow || window.jQuery || window.$,
    prechatFields = {};
  window.chatWindowName = "newwindow"; //small tweak to original code, so the test passes.


  var eventDispatcher = {};
  var container;

  window._la = window._la || [];
  _la.push(function() {
    _la.setPrechatFields({});
  });



  window.initLiveAgent = function(config) {
    _la.initWasCalled = true;
    $(function() {
      setupIframeLiveAgent(config).then(function(obj) {
        $.extend(_la, obj);

        runFunc(_la);

        function runFunc(_la) {
          var func;
          for (var i = 0; i < _la.length; i++) {
            func = _la[i];
            if (typeof func === "function") {
              func();
            }
          }
          _la.length = 0;
          _la.push = function(func) {
            func();
          };
        }
      });
    });
    return _la;
  };


  // chat button is not always


  function setupIframeLiveAgent(config) {
    var deferred = $.Deferred();
    createLiveAgentIframe(config, $("body"))
      .then(function(iframe) {
        var win = iframe.contentWindow;
        //console.log("iframe live agent init done");

        //console.log("live agent 2");
        win.liveagent._.handlePingBak = win.liveagent._.handlePing;
        win.liveagent._.handlePing = function handlePingCustom(data) {
          //procoessMessage(data);
          for (var i = 0; i < data.messages.length; i++) {
            if (data.messages[i].type === "Settings") {
              var buttons = data.messages[i].message.buttons;
              buttons = getInviteTypeButton(buttons);
              $.extend(obj.inviteButtons, createInviteButtons(buttons, win));
              //console.log(5, buttons);
              setTimeout(function() {
                deferred.resolve(obj);
              }, 1);
            }
          }
          win.liveagent._.handlePingBak(data);
        };

        win.liveagent.getPrechatInfo = function() {
          return {
            "config": config,
            "fields": prechatFields,
            'activeButtonIds': getIds(_la.chatButtons.getOnlineButtons()),
            'buttonsInfo': _la.chatButtons.getButtonsInfo()
          };
        }

        var obj = {
          config: config,
          iframe: iframe,
          win: win,
          chatButtons: createButtons(config.chatButtonIds, win),
          inviteButtons: [],
          setCustomVariable: function(n, v) {
            if (config.debug) {
              console.log("setCustomVariable: " + n + " = " + v);
            }
            win.liveagent.setCustomVariable(n, v);
            //liveagent.setCustomVariable('LoginAttempts', 2);
          },

          addButtonEventHandler: function(callback) {
            if (config.debug) {
              console.log("add buttons handler");
            }
            var that = this;
            $(eventDispatcher).on("liveAgentEvent",
              function(event, type, buttonId) {
                //console.log(type, buttonId);
                //console.log(event, type, buttonId);
                callback(type, buttonId);
              });
          },
          setPrechatFields: function(fields) {
            //console.log("setup PreChat Fields: ", fields);
            //fields.chatButtonIds = config.chatButtonIds;
            for (var k in fields) {
              //prechatFields["liveagent.prechat:" + k] = fields[k];
              prechatFields[k] = fields[k];
            }
          },
          setConfigField: function(k, v) {
            config[k] = v;
          }
        };
        //deferred.resolve(obj);
      });
    return deferred.promise();
  }

  function createLiveAgentIframe(config, parent) {
    var deferred = $.Deferred();

    loadIframeScript(config.srcUrl, "liveagent_iframe").then(function(iframe) {
      var win = iframe.contentWindow;
      if (config.debug) {
        console.log("script done");
      }
      if (config.debug) {
        win.liveagent.enableLogging();
      }
      win.liveagent.init(config.initUrl, config.deploymentId, config.orgId);

      if (!win._laq) {
        win._laq = [];
      }

      win._laq.push(function() {
        deferred.resolve(iframe);
      });
    });

    return deferred.promise();
  }


  function createButtons(buttonIds, win) {
    var button;
    var buttons = [];
    var i = 0;
    for (i = 0; i < buttonIds.length; i++) {
      button = createButton(buttonIds[i], win);
      buttons.push(button);
    }
    buttons.getOnlineButtons = function() {
      var onlineButtons = [];
      for (i = 0; i < buttons.length; i++) {
        if (buttons[i].isOnline()) {
          onlineButtons.push(buttons[i]);
        }
      }
      return onlineButtons;
    };
    buttons.getButtonsInfo = function() {
      var  buttonsInfo = [];
      for (i = 0; i < buttons.length; i++) {
        buttonsInfo.push({id: buttons[i].buttonId, online: buttons[i].isOnline()})
      }
      return buttonsInfo;
    };
    return buttons;
  }

  function createButton(buttonId, win) {
    var dummyButton = $("<div><div");
    var dummyButtonOffline = $("<div><div");
    dummyButton.css("display", "none");

    var button = {
      buttonId: buttonId,
      isOnline: function() {
        var online = dummyButton.css("display") != 'none';
        //console.log(dummyButton.css("display"));
        return online;
      },
      startChat: function() {
        win.liveagent.setChatWindowHeight(480);
        return win.liveagent.startChatWithWindow(buttonId, chatWindowName);
      },
      rejectChat: function() {
        return win.liveagent.rejectChat(buttonId);
      }
    };



    win.liveagent.showWhenOnline(buttonId, dummyButton[0]);
    //win.liveagent.showWhenOffline(buttonId, dummyButtonOffline[0]);
    win.liveagent.addButtonEventHandler(buttonId, function(e) {
      setTimeout(function() {
        $(eventDispatcher).triggerHandler("liveAgentEvent", [e, buttonId]);
      }, 1);
    });


    return button;
  }

  function createInviteButtons(buttonsData, win) {

    var button;
    var buttons = [];
    var i = 0;
    //console.log(buttonsData);
    for (i = 0; i < buttonsData.length; i++) {
      button = createInviteButton(buttonsData[i], win);
      buttons.push(button);
    }
    buttons.getOnlineButtons = function() {
      var onlineButtons = [];
      for (i = 0; i < buttons.length; i++) {
        if (buttons[i].isOnline()) {
          onlineButtons.push(buttons[i]);
        }
      }
      return onlineButtons;
    };
    return buttons;
  }

  function createInviteButton(buttonData, win) {
    var container = $("body", win.document);
    var dummyButton = $("<div id='liveagent_invite_button_" + buttonData.id + "'>test<div");
    dummyButton.css("display", "none");
    dummyButton.appendTo(container);

    win.liveagent.addButtonEventHandler(buttonData.id, function(e) {
      console.log("add invite button handler: " + buttonData.id);
      //console.log(5, e);
      var params = [e, buttonData.id];
      //console.log(10, params);
      setTimeout(function() {

        //console.log("add invite button handler");
        $(eventDispatcher).triggerHandler("liveAgentEvent", params);
      }, 1);

    });



    var result = {
      getData: function() {
        return buttonData;
      },
      isOnline: function() {
        var offline = (dummyButton.css("display") == 'none') || (dummyButton.css("top").replace("px", "") < 0);
        //console.log(online, dummyButton.css("top").replace("px", ""));
        //console.log(!offline);
        return !offline;
      },
      getStyle: function() {
        //console.log(dummyButton.attr("style"));
        return dummyButton.attr("style");
      },
      startChat: function() {
        //console.log("start chat: " + buttonData.id);
        win.liveagent.setChatWindowHeight(480);
        return win.liveagent.startChatWithWindow(buttonData.id, chatWindowName);
      },
      rejectChat: function() {
        return win.liveagent.rejectChat(buttonData.id);
      }
    };
    return result;
  }





  function getInviteTypeButton(buttons, type) {
    return $.grep(buttons, function(button) {
      return (button.type === "Invite") && !button.inviteImageUrl;
    });
  }

  function getButtonType(buttons, type) {
    return $.grep(buttons, function(button) {
      return button.type === "Invite";
    });
  }

  function loadIframeScript(url, id) {
    var deferred = $.Deferred();
    var iframe = $('<iframe id="' + id + '" style="width:0;hight:0;border:none;display:none" ></iframe>').appendTo('body')[0];

    var win = iframe.contentWindow;

    var doc = iframe.contentWindow.document;

    iframe.onload = function() {
      deferred.resolve(iframe);
    };
    //doc._l = callback;
    doc.write("<body><script src='" + url + "'></script></body>");
    //doc.write('<body onload="document._l();">');
    doc.close();
    return deferred.promise();
  }

  function getIds(buttons) {
    var ids = [];
    for (var i = 0; i < buttons.length; i++) {
      ids.push(buttons[i].buttonId);
    }
    return ids;
  }

  if (!String.prototype.endsWith) {
    String.prototype.endsWith = function(searchString, position) {
      var subjectString = this.toString();
      if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
        position = subjectString.length;
      }
      position -= searchString.length;
      var lastIndex = subjectString.lastIndexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
    };
  }

})();



// WEBPACK FOOTER //
// ./assets/js/third-party/live-agent.js